import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Typography, Button, Row, Space } from 'antd'

const ConfirmationModal = ({
  visible,
  title,
  content,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  isLoading,
}) => (
  <Modal
    visible={visible}
    footer={null}
    closable={false}
    centered
    width={400}
    destroyOnClose
    onCancel={onCancel}
    maskStyle={{
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(10px)',
    }}
  >
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography.Title level={3} style={{ marginBottom: '16px' }}>
        {title}
      </Typography.Title>

      <div style={{ marginBottom: '24px' }}>
        <Typography.Text style={{ fontSize: '16px' }}>{content}</Typography.Text>
      </div>

      <Row justify="end">
        <Space>
          <Button onClick={onCancel} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button type="primary" onClick={onConfirm} loading={isLoading}>
            {confirmText}
          </Button>
        </Space>
      </Row>
    </div>
  </Modal>
)

ConfirmationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  isLoading: PropTypes.bool,
}

ConfirmationModal.defaultProps = {
  title: 'Confirm Action',
  content: 'Are you sure?',
  confirmText: 'Submit',
  cancelText: 'Cancel',
  isLoading: false,
}

export default ConfirmationModal
